import { render, staticRenderFns } from "./fccGabaritosProvas.vue?vue&type=template&id=320aeec2"
import script from "./fccGabaritosProvas.vue?vue&type=script&lang=js"
export * from "./fccGabaritosProvas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports